import { lStorage } from "../../../utils/localStorage/lStorage";
import { stringifyDate } from "./stringifyDate";
import config from "../config.json";

const getServerDays = async () => {
    return await lStorage.get("stats/routine");
};

const getDays = async () => {
    const daysFromServer = await getServerDays();

    return daysFromServer ?? [];
};

export const getDay = async (date = new Date()) => {
    const existingDays = await getDays();

    const today = existingDays.find((day) => day.date === stringifyDate(date));

    if (today) {
        return today;
    } else {
        return {
            date: stringifyDate(date),
            morning: config.morning.map((task) => ({
                ...task,
                type: task.type ?? "regular",
                isCompleted: false,
            })),
            evening: config.evening.map((task) => ({
                ...task,
                type: task.type ?? "regular",
                isCompleted: false,
            })),
        };
    }
};

export const postDay = async (freshDay) => {
    const days = await getDays();

    let today = days.find((day) => day.date === stringifyDate(new Date()));

    if (!today) {
        today = { date: stringifyDate(new Date()) };
        days.push(today);
    }

    today.morning = freshDay.morning;
    today.evening = freshDay.evening;

    await lStorage.set("stats/routine", days);
};
